module.exports = __webpack_public_path__ + "img/full2-min.629b67d4.png";